<p-fluid>
  <div
    [class.xofmanyrequired]="xOfManyErrors() && isOneOfManyRequired()"
    class="w-100"
  >
    <p-multiSelect
      #tradePartnerSelection="ngModel"
      name="tradePartnerSelection"
      [options]="tradePartnerOptions"
      [required]="required()"
      [(ngModel)]="selectedTradePartners"
      (onChange)="onChange()"
      resetFilterOnHide="true"
      [placeholder]="label"
      [selectionLimit]="selectionLimit()"
      [maxSelectedLabels]="maxSelectedLabels()"
      appendTo="body"
      [disabled]="disabled"
    />
  </div>
  <error-message [errorControl]="tradePartnerSelection">
    @if (tradePartnerSelection?.errors?.required) {
      <span>Please select at least one trade partner to continue.</span>
    }
  </error-message>
</p-fluid>
